import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import axios from 'axios';
import { showToast } from '../components/Toast';
import './Login.css';
import { DSInput, DSButton } from '../design-system/primitives';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function Login({ onLogin }) {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await authService.login(email, password);
      onLogin();
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Register the user - backend will generate temp password and email it
      await axios.post(`${API_URL}/auth/register`, {
        email,
        firstName,
        lastName,
        phone
      });

      // Show success message
      showToast(`Account created! Check your email (${email}) for your temporary password.`, 'success');
      
      // Switch to login mode
      setIsSignup(false);
      setEmail(email); // Keep email filled in for convenience
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMode = () => {
    setIsSignup(!isSignup);
    setError('');
    if (isSignup) {
      // Switching from signup to login - keep email if set
    } else {
      // Switching from login to signup - clear all fields
      setEmail('');
      setPassword('');
    }
    setPhone('');
    setFirstName('');
    setLastName('');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src="/logo.png" alt="Capital Pinball" className="login-logo" />
        </div>

        {isSignup ? (
          <form onSubmit={handleSignup} className="login-form">
            <h2 style={{ color: 'var(--ds-color-textDefault)', marginBottom: '10px', fontSize: '20px', textAlign: 'center' }}>
              Create Account
            </h2>
            <p style={{ fontSize: '13px', color: 'var(--ds-color-textMuted)', textAlign: 'center', marginBottom: '20px' }}>
              We'll email you a temporary password to get started
            </p>
            
            {error && <div className="alert alert-error">{error}</div>}

            <DSInput label="First Name"
                type="text"
                id="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                autoFocus
                disabled={isLoading} />

            <DSInput label="Last Name"
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={isLoading} />

            <DSInput label="Email"
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading} />

            <DSInput label="Phone"
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                disabled={isLoading} />

            <DSButton tone="primary" appearance="solid" className="login-button" type="submit" disabled={isLoading}>
              {isLoading ? 'Creating Account...' : 'Create Account'}
            </DSButton>
          </form>
        ) : (
          <form onSubmit={handleLogin} className="login-form">
            {error && <div className="alert alert-error">{error}</div>}

            <DSInput label="Email"
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                disabled={isLoading} />

            <DSInput label="Password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading} />

            <div style={{ textAlign: 'right', marginBottom: '15px' }}>
              <Link 
                to="/forgot-password" 
                style={{ fontSize: '14px', color: 'var(--ds-global-color-pink500)' }}
              >
                Forgot password?
              </Link>
            </div>

            <DSButton tone="primary" appearance="solid" className="login-button" type="submit" disabled={isLoading}>
              {isLoading ? 'Logging in...' : 'Login'}
            </DSButton>
          </form>
        )}

        <div className="login-footer">
          <p>
            {isSignup ? (
              <>Already have an account? <button type="button" onClick={toggleMode} style={{ color: 'var(--ds-global-color-pink500)', background: 'none', border: 'none', padding: 0, cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }}>Login</button></>
            ) : (
              <>Don't have an account? <button type="button" onClick={toggleMode} style={{ color: 'var(--ds-global-color-pink500)', background: 'none', border: 'none', padding: 0, cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }}>Create one now</button></>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
